// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"be1bc528","592":"98b08754","663":"a528f91f","684":"7dc8650c","738":"9c08d403","790":"ee85ec8f","861":"b83ffded","864":"a2761bae"}[chunkId] + ".chunk.css";
};